<template>
    <div>
        <nav-bar>
            <nav-bar-item path="/home" to="/home" activeColor="red">
                <div slot="item-text">首页</div>
            </nav-bar-item>
			<nav-bar-item path="/sentiment" to="/sentiment/cyclicality" >
				<div slot="item-text">情绪</div>
			</nav-bar-item>
			<nav-bar-item path="/review" to="/review/uplimit/reason" >
				<div slot="item-text">复盘</div>
			</nav-bar-item>
			<nav-bar-item path="/wonder" to="/wonder/yjj/ml" >
				<div slot="item-text">热点</div>
			</nav-bar-item>
			<nav-bar-item path="/download" to="/download" class="download-nav-item">
				<div slot="item-text"><span class="d-none d-md-inline">App</span>下载</div>
			</nav-bar-item>
            <!-- <nav-bar-item path="/robot" to="/wonder/yjj/ml" >
                <div slot="item-text">推演</div>
            </nav-bar-item> -->
            <!-- <nav-bar-item path="/wonder" to="/wonder/topic/table" >
                <div slot="item-text">题材表格</div>
            </nav-bar-item> -->
			<!-- <nav-bar-item path="/robot" to="/robot/hot">
				<div slot="item-text">机器人</div>
			</nav-bar-item> -->
            <nav-bar-item path="/contact" to="/contact">
                <div slot="item-text">捐赠</div>
            </nav-bar-item>
            <nav-bar-item path="/feedback" to="/feedback">
                <div slot="item-text">意见</div>
            </nav-bar-item>
            <template v-slot:right>
                <UserMenu />
            </template>
        </nav-bar>
    </div>
</template>

<script>
// 原来的导入语句可能是这样的:
// import NavBar from 'components/navbar/NavBar.vue'

// 修改为使用正确的相对路径:
// import NavBar from './NavBar.vue'
// 或者使用 @ 别名 (指向src目录):
    import NavBar from '@/components/navbar/Navbar.vue'
    import NavBarItem from '@/components/navbar/NavBarItem.vue'
    import UserMenu from '@/components/navbar/UserMenu.vue'
    
    export default {
        components: {
            NavBar,
            NavBarItem,
            UserMenu,
        },
        data() {
            return {
                theme: 'light'
            }
        },
        methods: {
            applyTheme(){
                const isDark = this.theme === 'dark'
                document.body.classList.toggle('theme-dark', isDark)
                localStorage.setItem('site.theme', this.theme)
            },
            toggleTheme(){
                this.theme = (this.theme === 'dark') ? 'light' : 'dark'
                this.applyTheme()
            }
        },
        computed:{
            themeLabel(){ return this.theme === 'dark' ? '浅色皮肤' : '黑色皮肤' }
        },
        mounted(){
            const t = localStorage.getItem('site.theme')
            if(t){ this.theme = t }
            this.applyTheme()
        }
    }
</script>

<style>
</style>
